function e(n){return n?!!(n.organization||n.baseUrl):!1}export{e as isConnectionOptions};
